import { useQuery } from '@tanstack/react-query';

import logo from '@repo/media/logo/nljv/NorthernLights_RGB_Small_Teal.svg';

import { OverviewDashboard, overviewDashboardQuery, OverviewHeader } from '@repo/features/overview-dashboard';

import { fetchOverview, framed, NoAccessError, pca } from './api.ts';

const query = overviewDashboardQuery(fetchOverview);

export function App() {
  const { data, error, isError, isLoading } = useQuery({ ...query, retry: (count, e) => !(e instanceof NoAccessError) && count < 3 });

  if (error instanceof NoAccessError)
    return <NoAccess />;

  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-[120rem] flex-col gap-4 bg-primary-contrast p-6">
      <OverviewHeader data={data} isError={isError} isLoading={isLoading} leading={<Brand />} />
      {data && <OverviewDashboard data={data} theme="light" />}
    </main>
  );
}

// The logo and name as the portal header shows them (cv-internal logo-link.tsx), without the link home.
function Brand() {
  return (
    <div className="flex items-center gap-2.5">
      <img className="h-6" alt="" src={logo} />
      <span className="text-sm font-semibold whitespace-nowrap text-primary-800">Northern Lights</span>
    </div>
  );
}

function NoAccess() {
  const account = pca.getActiveAccount() ?? pca.getAllAccounts()[0];
  return (
    <main className="flex min-h-dvh items-center justify-center bg-primary-contrast p-6">
      <div className="space-y-3 rounded-xl border border-dashed border-secondary-300 p-8 text-center text-sm text-secondary-600">
        {framed
          ? <p>No access from this network.</p>
          : (
              <>
                <p>{`No access for ${account?.username ?? 'this account'}.`}</p>
                <button type="button" className="font-medium text-primary-700 underline" onClick={() => void pca.logoutRedirect()}>Sign out</button>
              </>
            )}
      </div>
    </main>
  );
}
